import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import {
  Button,
  Card,
  CardContent,
  makeStyles,
  TextField,
} from "@material-ui/core";
import * as Yup from "yup";
import AppState from "../../context/AppContext";
import { Link, Navigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  input: {
    minWidth: "360px",
    backgroundColor: "white",
    color: "black",
    "& .MuiFormHelperText-root": {
      color: "black",
    },
    "& .Mui-error": {
      color: "black",
    },
  },
  errorText: {
    color: "red",
    fontSize: "14px",
    fontWeight: "bold",
    verticalAlign: "middle",
  },
  card: {
    width: "100%",
    maxWidth: "360px",
    marginTop: "20px auto",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  cardHeader: {
    textAlign: "center",
    color: "red",
    fontWeight: "bold",
    fontFamily: '"Great Vibes", cursive',
  },
  error: {
    verticalAlign: "middle",
  },
  submitButton: {
    margin: "20px",
    backgroundColor: "green",
    color: "white",
    float: "left",
  },
  closeButton: {
    margin: "20px",
    float: "right",
  },
}));

const Register = () => {
  const classes = useStyles();
  const context = useContext(AppState);
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState("");
  const validationSchema = Yup.object().shape({
    userName: Yup.string().required("Username is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    passwordConfirmation: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Password confirmation is required"),
  });
  const onSubmit = (values) => {
    const data = {
      userName: values.userName,
      email: values.email,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation,
    };
    context
      .createUser(data)
      .then((data) => {
        if (data) {
          setRedirect(true);
        }
      })
      .catch((error) => {
        setError(error.response.data.error);
        setRedirect(false);
      });
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: {
      userName: "",
      email: "",
      password: "",
      passwordConfirmation: "",
    },
    validationSchema: validationSchema,
    onSubmit,
  });
  if (redirect) return <Navigate to="/login" />;
  return (
    <Card className={classes.card}>
      <CardContent>
        <form
          onSubmit={handleSubmit}
          autoComplete="off"
          className={classes.form}
        >
          <TextField
            name="userName"
            value={values.userName}
            onChange={handleChange}
            id="userName"
            label="User Name"
            type="text"
            variant="outlined"
            margin="normal"
            fullWidth
            placeholder="Enter your username"
            onBlur={handleBlur}
            error={Boolean(errors.userName && touched.userName)}
            helperText={touched.userName ? errors.userName : ""}
          />
          <TextField
            variant="outlined"
            margin="normal"
            label="Email"
            value={values.email}
            onChange={handleChange}
            id="email"
            type="email"
            fullWidth
            placeholder="Enter your email"
            onBlur={handleBlur}
            error={Boolean(errors.email && touched.email)}
            helperText={touched.email ? errors.email : ""}
          />
          <TextField
            name="password"
            label="Password"
            type="password"
            variant="outlined"
            margin="normal"
            id="password"
            fullWidth
            placeholder="Enter your password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(errors.password && touched.password)}
            helperText={touched.password ? errors.password : ""}
          />
          <TextField
            name="passwordConfirmation"
            label="Password Confirmation"
            type="password"
            variant="outlined"
            margin="normal"
            fullWidth
            id="passwordConfirmation"
            placeholder="Confirm your password"
            value={values.passwordConfirmation}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(
              errors.passwordConfirmation && touched.passwordConfirmation
            )}
            helperText={
              touched.passwordConfirmation ? errors.passwordConfirmation : ""
            }
          />
        </form>
        <p className={classes.errorText}>{error}</p>
        <Button
          variant="contained"
          className={classes.submitButton}
          onClick={handleSubmit}
        >
          Register
        </Button>
        <Button
          variant="contained"
          className={classes.closeButton}
          onClick={() => resetForm()}
        >
          Cancel
        </Button>
        <br />
        <div className="reset">
          <Link to="/login">Already have an account? Login</Link>
        </div>
      </CardContent>
    </Card>
  );
};
export default Register;
